/* eslint-disable no-magic-numbers */
import { Color } from '@/types/models';

const FULL_OPACITY_HEX = 'FF';

/**
 * Normalizes a hex color to the #RRGGBBAA form expected by the API.
 * Accepts #RGB, #RRGGBB and #RRGGBBAA, missing alpha defaults to fully opaque.
 */
export const normalizeHexColor = (hex: string): Color => {
  const sanitizedHex = hex.replace(/^#/, '').toUpperCase();

  if (![3, 6, 8].includes(sanitizedHex.length)) {
    throw new Error('Invalid HEX color. Must be 3, 6 or 8 characters.');
  }

  const expandedHex =
    sanitizedHex.length === 3
      ? sanitizedHex
          .split('')
          .map(char => `${char}${char}`)
          .join('')
      : sanitizedHex;

  const alphaHex = expandedHex.length === 8 ? '' : FULL_OPACITY_HEX;

  return `#${expandedHex}${alphaHex}`;
};
